export default {
  'register.alert.confirm': '利用規約に同意してください',
  'register.alert.register_fail': '登録に失敗しました。もう一度お試しください',
  'register.alert.phone_number.exists':
    'この携帯番号は既に使用されています。別の携帯番号を入力してください。',
  'register.alert.phone_number.verify_fail': '携帯番号の認証に失敗しました。再入力してください',
  'register.alert.email.exists': 'このE-mailは既に使用されています。別のE-mailを入力してください。',
  'register.alert.email.verify_fail': 'E-mailの認証に失敗しました。再入力してください',
  'register.alert.birthday.verify_fail': '生年月日の認証に失敗しました。再入力してください',
  'register.alert.gender.verify_fail': '性別の認証に失敗しました。再入力してください',
  'register.alert.city.verify_fail': '居住地の認証に失敗しました。再入力してください',
  'register.alert.job.verify_fail': '職業の認証に失敗しました。再入力してください',
  'register.alert.education_level.verify_fail': '学歴の認証に失敗しました。再入力してください',
  'register.alert.marriage.verify_fail': '婚姻状況の認証に失敗しました。再入力してください',
  'register.alert.interest.verify_fail': '興味の認証に失敗しました。再入力してください',
  'register.alert.diet.verify_fail': '食の好みの認証に失敗しました。再入力してください',
  'register.alert.line_account.registered': 'このLINEアカウントは既に会員登録済みです。',
  'register.alert.otp.verify_fail': 'OTP認証に失敗しました。もう一度お試しください。',
  'register.alert.field_required': '未入力の項目があります。もう一度お試しください。',
  'register.alert.referral_code': '入力した招待コードが正しくありません。ご確認ください！',
  'register.alert.please_select': '選択してください',
  'register.alert.number_required': '数字を入力してください',
  'register.alert.number_length': '最大18桁まで入力できます。再入力してください',
  'register.phone_number': '携帯番号',
  'register.phone_number.required': '携帯番号を入力してください',
  'register.phone_number.format_error': '携帯番号の形式が正しくありません',
  'register.phone_number.not_match': '携帯番号が一致しません',
  'register.phone_number.enter_again': 'もう一度携帯番号を入力してください',
  'register.name': '氏名',
  'register.name.required': '氏名を入力してください',
  'register.name.format_error': '英字と漢字のみ入力できます',
  'register.birth': '生年月日',
  'register.birth.required': '生年月日を入力してください',
  'register.email': 'E-mail',
  'register.email.required': 'E-mailを入力してください',
  'register.email.format_error': 'E-mailの形式が正しくありません',
  'register.gender': '性別',
  'register.gender.required': '性別を選択してください',
  'register.city': '居住地',
  'register.city.required': '居住地を選択してください',
  'register.job': '職業',
  'register.job.required': '職業を選択してください',
  'register.eduction_level': '学歴',
  'register.eduction_level.required': '学歴を選択してください',
  'register.marriage': '婚姻状況',
  'register.marriage.required': '婚姻状況を選択してください',
  'register.habit': '興味',
  'register.habit.required': '興味を選択してください',
  'register.diet': '食の好み',
  'register.diet.required': '食の好みを選択してください',
  'register.agree': '同意します',
  'register.term': '利用規約',
  'register.privacy_policy': 'プライバシーポリシー',
  'register.account_verification': 'アカウント認証',
  'register.member_information': '会員情報',
  'register.complete': '登録完了',
  'register.submit': '送信',
  'register.success': '登録が完了しました',
  'register.success_with_mgm':
    '登録が完了しました！5分以内に専用の登録特典をお受け取りいただけます',
  'register.country_code': '国番号',
  'register.country_code.required': '国番号を選択してください',
  'register.referral_code': '友達招待コード',
  'register.prev_step': '前へ',
  'register.next_step': '次へ',
} as Record<string, string>;
